const translations = {
    clientNameFieldPlaceholder: 'Client',
    farmNameFieldPlaceholder: 'Farm',
    incompleteSelectionWarning:
        'Incomplete selection will not be stored. Please complete Client and Farm selections.',
    label: 'Client | Farm'
};

export default translations;
